import { useMemo } from 'react';
import AccountsSection from './manage-options-sections/accounts-section';
import ProjectsSection from './manage-options-sections/projects-section';
import DatasourcesSection from './manage-options-sections/datasources-section';
import UsersSection from './manage-options-sections/users-section';

function ManageOptions({ options, optionsLoading, onOptionsChanged }) {
  const sourceDatasources = useMemo(
    () => options.datasources.filter((d) => d.kind === 'source'),
    [options.datasources],
  );

  if (optionsLoading) {
    return <p className="demo-env-mgmt-label">Loading…</p>;
  }

  return (
    <>
      <AccountsSection accounts={options.accounts} onChanged={onOptionsChanged} />
      <UsersSection users={options.users} accounts={options.accounts} onChanged={onOptionsChanged} />
      <ProjectsSection projects={options.projects} accounts={options.accounts} onChanged={onOptionsChanged} />
      <DatasourcesSection
        datasources={options.datasources}
        projects={options.projects}
        sourceDatasources={sourceDatasources}
        onChanged={onOptionsChanged}
      />
    </>
  );
}

export default ManageOptions;
